import OBase from './OBase';

import * as Geometry from '../geometry';

export default class ReverseList extends OBase {
  update () {
    let lInputTree = this.getObjectInput('List');
    let lOutput = this.getGenericObjectOutput('List');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < lInputTree.branches.length; i++) {
      var list = [...lInputTree.branches[i]];
      list.reverse();

      for (let j = 0; j < list.length; j++) {
        outTree.add(list[j], lInputTree.paths[i]);
      }
    }

    lOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/ReverseList.js